module.exports = __webpack_public_path__ + "img/03dcc00.jpg";